import { PhoneNumber } from "../misc/PhoneNumber";
import { useState } from "react";
import { useRecordContext, useTranslate, WithRecord } from "ra-core";

import { ArrayField } from "@/components/admin/array-field";
import { SingleFieldList } from "@/components/admin/single-field-list";
import { EmailField } from "@/components/admin/email-field";

import { Mail, Phone, Check } from "lucide-react";

import type { ReactNode } from "react";

import { translatePersonalInfoTypeLabel } from "./contactModel";

import type { Contact } from "../types";

export const ContactPersonalInfo = () => {
  const record = useRecordContext<Contact>();

  if (!record) {
    return null;
  }

  return (
    <div>
      <ArrayField source="phone_jsonb">
        <SingleFieldList className="flex-col gap-y-0">
          <PersonalInfoRow
            icon={<Phone className="w-4 h-4 text-muted-foreground" />}
            primary={<PhoneNumber source="number" />}
            showType
          />
        </SingleFieldList>
      </ArrayField>

      <ArrayField source="email_jsonb">
        <SingleFieldList className="flex-col gap-y-0">
          <EmailRow />
        </SingleFieldList>
      </ArrayField>
    </div>
  );
};

const EmailRow = () => {
  const record = useRecordContext<{
    email: string;
  }>();

  const translate = useTranslate();

  const [copied, setCopied] = useState(false);

  if (!record) {
    return null;
  }

  const handleCopy = () => {
    navigator.clipboard.writeText(record.email).then(() => {
      setCopied(true);

      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <PersonalInfoRow
      icon={
        <button
          data-mobile-control="compact"
          type="button"
          onClick={handleCopy}
          title={translate("crm.common.copy")}
          className="text-muted-foreground hover:text-foreground transition-colors cursor-pointer"
        >
          {copied ? (
            <Check className="w-4 h-4 text-green-500" />
          ) : (
            <Mail className="w-4 h-4" />
          )}
        </button>
      }
      primary={<EmailField source="email" />}
    />
  );
};

const PersonalInfoRow = ({
  icon,
  primary,
  showType,
}: {
  icon: ReactNode;

  primary: ReactNode;

  showType?: boolean;
}) => {
  const translate = useTranslate();

  return (
    <div className="flex flex-row items-center gap-x-2 py-1 min-h-6">
      {icon}

      <div className="flex flex-wrap gap-x-2 gap-y-0 text-sm">
        {primary}

        {showType ? (
          <WithRecord
            render={(row) =>
              row.type !== "Other" && (
                <span className="text-muted-foreground">
                  {translatePersonalInfoTypeLabel(row.type, translate)}
                </span>
              )
            }
          />
        ) : null}
      </div>
    </div>
  );
};
